// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowsRotateReverseDot16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrows-rotate-reverse-dot': IconArrowsRotateReverseDot;
    }
}

/**
 * The icon component for the 'arrowsRotateReverseDot' icon
 */
export class IconArrowsRotateReverseDot extends IconSvg {
    public constructor() {
        super(arrowsRotateReverseDot16X16);
    }
}

registerIconSvg('icon-arrows-rotate-reverse-dot', IconArrowsRotateReverseDot);
export const iconArrowsRotateReverseDotTag = 'nimble-icon-arrows-rotate-reverse-dot';
